import styles from './IconButton.module.css';

function IconButton({ 
    children, 
    onClick, 
    variant = 'primary', 
    className = '', 
    disabled = false,
    size = 'medium',
    ...props 
}) {
    const buttonClass = `${styles.iconButton} ${styles[variant] || styles.primary} ${styles[size] || styles.medium} ${className}`.trim();

    return (
        <button 
            className={buttonClass} 
            onClick={onClick} 
            disabled={disabled} 
            {...props}
            type="button"
        >
            {children}
        </button>
    );
}

export default IconButton;
